module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/4-ab784df63a9eaddbbcd90e7243b8f438.jpg";